import { Box } from '@chakra-ui/react';
import { ClusterMap } from 'components/widgets/ClusterMap';
import OverlayMenu from 'components/widgets/ProjectInsights/OverlayMenu';
import {
  useHandleMapCenterUpdate,
  useHandleCoordinatesUpdate,
} from 'hooks/useProjectMap';
import { useUserStateSelection } from 'state/dashboard';

const containerStyle = {
  height: '100%',
  position: 'relative',
};

export const Map = () => {
  const [selectedState] = useUserStateSelection();

  useHandleMapCenterUpdate();
  useHandleCoordinatesUpdate();

  return (
    <Box sx={containerStyle}>
      <ClusterMap
        key={`project-search-map-${selectedState}`}
        defaultToSateliteView
        saveMapTypePreference
      />
      <OverlayMenu />
    </Box>
  );
};
